import { ConstraintWaterExpressBase } from './base/constraint-water-express-base';

export class ConstraintWaterExpress extends ConstraintWaterExpressBase { }